import { useMemo } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from 'src/modules/auth';

export default function PublicRoutes() {
    const { isAuthenticated } = useAuth();

    return useMemo(() => (isAuthenticated ? <Navigate to={'/'} /> : <Outlet />), [isAuthenticated]);
}
